import { api } from "@/lib/api";

const SESSION_KEY = "emi_session_id";
const LAST_SEEN_KEY = "emi_session_last";
const IDLE_MS = 30 * 60 * 1000; // 30 minutos

function uid() {
    if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
    return "s_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
}

export function getOrCreateSessionId() {
    if (typeof window === "undefined") return "ssr";
    try {
        const now = Date.now();
        const lastSeen = parseInt(localStorage.getItem(LAST_SEEN_KEY) || "0", 10);
        let sid = localStorage.getItem(SESSION_KEY);
        if (!sid || !lastSeen || now - lastSeen > IDLE_MS) {
            sid = uid();
            localStorage.setItem(SESSION_KEY, sid);
        }
        localStorage.setItem(LAST_SEEN_KEY, String(now));
        return sid;
    } catch {
        return "no-storage";
    }
}

function parseUTM(search) {
    const utm = {};
    try {
        const sp = new URLSearchParams(search || window.location.search);
        ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"].forEach((k) => {
            const v = sp.get(k);
            if (v) utm[k] = v;
        });
    } catch {
        // noop
    }
    return utm;
}

const inflight = new Set();

export async function track(name, props = {}) {
    if (typeof window === "undefined") return;
    // Evitar duplicados exactos en ráfaga
    const key = `${name}:${window.location.pathname}`;
    if (inflight.has(key)) return;
    inflight.add(key);
    setTimeout(() => inflight.delete(key), 600);

    try {
        await api.post(
            "/track",
            {
                name,
                session_id: getOrCreateSessionId(),
                page: window.location.pathname + window.location.search,
                referrer: document.referrer || "",
                user_agent: navigator.userAgent || "",
                props: props || {},
                utm: parseUTM(),
                ts: new Date().toISOString(),
            },
            { withCredentials: false },
        );
    } catch {
        // analytics nunca rompe la UI
    }
}

// Hook a usar adentro del Router para registrar page_view en cada navegación
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function PageTracker() {
    const loc = useLocation();
    useEffect(() => {
        track("page_view", { path: loc.pathname });
    }, [loc.pathname, loc.search]);
    return null;
}
